import LocalStorageConst from "@/constants/LocalStorageConst"
import CustomerService from "@/services/customerService"

import { AuthStore } from "@/stores/authentication"
import { WritableComputedRef } from "vue"
import { LanguageEnum } from "@/enums"
import { IDefaultResponse } from "@/interface/services"
import { useSetLangQuasar } from "@/composables/useSetLangQuasar"

const updateLocale = (value: string, locale: WritableComputedRef<string>) : Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
        localStorage.setItem(LocalStorageConst.LOCALE, value)
        locale.value = value
        resolve(true)
    })
}

export const changeLanguage = async (authStore: AuthStore|null, value: string|LanguageEnum, locale: WritableComputedRef<string>, updateDbValue = true) : Promise<boolean> => {
    useSetLangQuasar(authStore, value);
    if (authStore && authStore.isAuthenticated && updateDbValue) {
        return Promise.resolve(true)
            .then(() => {
                return CustomerService.changeAppLanguage(value)
                    .then((response: IDefaultResponse) => {
                        if (response.success) {
                            authStore.updateLanguage(value)
                        }
                        
                        return true
                    })
                    .catch((error) => {
                        console.error(error)
                        return false
                    })
                })
            .then(() => {
                return updateLocale(value, locale)
            })
    } else {
        return updateLocale(value, locale)
    }
}

export const getBrowserLocale = () : string|null => {
    let lang = undefined
    if (navigator.language) {
        lang = navigator.language
    } else if (navigator.languages) {
        lang = navigator.languages[0]
    }
    if (!lang) {
        return null
    }

    return lang.split(/-|_/)[0];
}